module.exports = __webpack_public_path__ + "static/media/Banner-Unimed-mobile.f1aab22d.png";